<template>
  <div>
    <div class="is-flex is-flex-direction-row is-align-items-center">
      <div class="setting-label has-text-weight-bold">Colors</div>
      <div class="setting-control is-flex is-flex-direction-row is-align-items-center">
        <div class="mr-1"><input type="color" name="c1" v-model="set.c1"></div>
        <div><input type="color" name="c2" v-model="set.c2"></div>
      </div>
    </div>
    <div class="mt-2 is-flex is-flex-direction-row is-align-items-center">
      <div class="setting-label has-text-weight-bold">Radius</div>
      <div class="setting-control"><b-numberinput :editable="false" :exponential=".3" expanded size="is-small" type="is-dark" controls-position="compact" min="1" max="20" v-model="set.radius"></b-numberinput></div>
    </div>
    <div class="mt-2 is-flex is-flex-direction-row is-align-items-center">
      <div class="setting-label has-text-weight-bold">Stroke</div>
      <div class="setting-control"><b-numberinput :editable="false" :exponential=".3" expanded size="is-small" type="is-dark" controls-position="compact" min="1" max="50" v-model="set.stroke"></b-numberinput></div>
    </div>
    <div class="mt-2 is-flex is-flex-direction-row is-align-items-center">
      <div class="setting-label has-text-weight-bold">Speed</div>
      <div class="setting-control"><b-numberinput :editable="false" :exponential=".3" expanded size="is-small" type="is-dark" controls-position="compact" min="1" max="30" step="1" v-model="set.speed"></b-numberinput></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    settings: Object
  },
  data: function () {
    return {
      set: this.settings
    }
  },
  watch: {
    settings: function (newSettings) {
      this.set = newSettings
    }
  }
}
</script>

<style>

</style>
